import angular from 'angular';

angular.module('cloudX').directive('cxUserSetting', [
  function() {
    return {
      restrict: 'A',
      scope: {
        data: '=cxUserSetting',
        key: '@settingKey',
      },
      controller: [
        '$scope',
        'userData',
        function($scope, userData) {
          if (!$scope.key) return;

          $scope.$watch('data', function(newValue, oldValue) {
            if (newValue !== oldValue) userData.set($scope.key, newValue);
          });

          //Load setting from userData
          var data = userData.get($scope.key, null);
          if (data != null) $scope.data = data;
        },
      ],
    };
  },
]);
